// Detail paginator total. In selection mode the checked set is only partly
// materialized — the rest lives in selectedVirtualRows (select-all on a lazy
// dataset checks the loaded page + a count), so both parts must be summed to
// match the counter shown in the list.
export const getDetailPaginatorTotal = (
  loadedRowsCount: number,
  selectedVirtualRows: number,
  showSelectedRows: boolean,
  totalRowsCount: number
) => {
  if (showSelectedRows) return loadedRowsCount + selectedVirtualRows;
  if (!totalRowsCount) return loadedRowsCount;
  return totalRowsCount;
};
